export default __webpack_public_path__ + "static/media/gallery-2-2.789158ca.webp";